import React, { FC, useRef, useState, useEffect } from "react";
import styles from "./faq.module.scss";
import Breadcrumbs from "../../componsnts/common/breadcrumbs/breadcrumbs";
import ScrollToTop from "../../componsnts/common/scroll-to-top/scroll-to-top";
import faqService from "../../service/faq/faq";
import { useMutation } from 'react-query';
import SectionTitle from "../../componsnts/common/sectionTitle/sectionTitle";

const FAQ: FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [faqData, setFaqData] = useState<any[]>([]);

  const {
    mutate: getFaqList,
    isLoading,
    error,
  } = useMutation({
    mutationFn: (role: string) => faqService.getFqaList(role),
    onSuccess: (res) => {
      const processedAnswers = res.Data.map((item: any) => {
        // 處理每一個問題回答
        const processedQuestionAnswer = item.QuestionAnswer.map((item2: any) => {
          // 在步驟之間插入 <br />
          const formattedAnswer = item2.Answer ? item2.Answer.replace(/(\r\n|\n|\r)/g, '<br />') : '';
          return { ...item2, Answer: formattedAnswer };
        });

        return { ...item, QuestionAnswer: processedQuestionAnswer };
      });

      setFaqData(processedAnswers); // 更新 faqData
    },
    onError: (err) => {
      console.error('Error fetching FAQ data:', err);
    },
  });

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    getFaqList("");
  }, [getFaqList]);

  useEffect(() => {
    contentRefs.current.forEach((el, i) => {
      if (el) {
        if (i === openIndex) {
          el.style.height = `${el.scrollHeight + 18}px`;
        } else {
          el.style.height = "0";
        }
      }
    });
  }, [openIndex]);

  return (
    <div className={styles["faq_container"]}>
      <ScrollToTop />
      <SectionTitle
        title="Q&A"
        titleColor="#fff"
        subTitle="QUESTIONS"
        subTitleColor="rgba(0, 149, 217, 0.50)"
        backgroundColor="#0077AE"
        breadcrumbs={true}
      />
      <div className="content_box">
        <div className="container">
          {faqData.map((item, index) => (
            <div key={index} className="container">
              {item.QuestionAnswer.map((qa: any, i: number) => (
                <div
                  onClick={() => toggleAccordion(index * 100 + i)}
                  className={`accordion_box ${openIndex === index * 100 + i ? "open_content" : ""}`}
                  key={i}
                >
                  <div
                    className={`accordion_title ${openIndex === index * 100 + i ? "open_content" : ""}`}
                  >
                    {qa.Question}
                    {openIndex === index * 100 + i ? (
                      <img className="faq_img" src="assets/images/FAQ/minus.png" alt="minus" />
                    ) : (
                      <img className="faq_img" src="assets/images/FAQ/plus.png" alt="plus" />
                    )}
                  </div>
                  <div
                    ref={(el) => (contentRefs.current[index * 100 + i] = el)}
                    className={`accordion_content ${openIndex === index * 100 + i ? "open_content" : ""}`}
                    dangerouslySetInnerHTML={{ __html: qa.Answer }}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;